import { useEffect } from 'react';

/**
 * Hook customizado para gerenciar o título da página
 * @param {string} pageTitle - Título específico da página (ex: "Meus Favoritos", "Checkout", etc.)
 */
function usePageTitle(pageTitle) {
  useEffect(() => {
    // Buscar nome da loja do sessionStorage
    const nomeLoja = sessionStorage.getItem('nome_loja') ||
                     sessionStorage.getItem('loja_nome') ||
                     sessionStorage.getItem('loja') ||
                     'Loja';

    // Formato: "Catálogo Imaginarium - Loja {Nome da loja} | {Título da página}"
    const fullTitle = pageTitle
      ? `Catálogo Imaginarium - Loja ${nomeLoja} | ${pageTitle}`
      : `Catálogo Imaginarium - Loja ${nomeLoja}`;

    document.title = fullTitle;

    // Cleanup: restaurar título padrão quando componente desmontar
    return () => {
      document.title = `Catálogo Imaginarium - Loja ${nomeLoja}`;
    };
  }, [pageTitle]);
}

export default usePageTitle;
